import { Component, Input, OnInit, Output } from '@angular/core';
import moment from 'moment';
import { Observable, ReplaySubject } from 'rxjs';
import { takeWhile } from 'rxjs/operators';
import { RecalculateContract } from '../../data-services/recalculate-transactions/recalculate-contracts/recalculate-contracts.model';
import { RecalculateSchedule } from '../../data-services/recalculate-transactions/recalculate-schedules/recalculate-schedules.model';
import { DisplayErrors } from '../../shared/errors-sidenav';
import { LoggingService } from '../../shared/services/logging';

@Component({
    selector: 'ef-contracts-presenter',
    templateUrl: './contracts-presenter.component.html',
    styleUrls: ['./contracts-presenter.component.scss'],
    standalone: false
})
export class ContractsPresenterComponent
    extends DisplayErrors<RecalculateContract>
    implements OnInit
{
    private ContractsSubject = new ReplaySubject<Array<RecalculateContract>>(1);
    private _contracts: Array<RecalculateContract>;
    @Input() set contracts(value: Array<RecalculateContract>) {
        this._contracts = value;
        this.ContractsSubject.next(value);
        this.log.verbose(value);
        if (value && value.length > 0) {
            this.periodString = `CONTRACTS SCHEDULED or WITH ACTIVITY -- ${moment(
                value[0].PeriodStartDate
            ).format('MM/DD/YYYY')} - ${moment(value[0].PeriodEndDate).format(
                'MM/DD/YYYY'
            )}`;
            this.dateText = `${moment(value[0].PeriodStartDate).format(
                'MM/DD/YYYY'
            )} - ${moment(value[0].PeriodEndDate).format('MM/DD/YYYY')}`;
        } else {
            this.periodString = `CONTRACTS SCHEDULED`;
        }
    }
    get contracts(): Array<RecalculateContract> {
        return this._contracts;
    }

    private SchedulesSubject = new ReplaySubject<Array<RecalculateSchedule>>(1);
    private _schedules: Array<RecalculateSchedule>;
    @Input() set schedules(value: Array<RecalculateSchedule>) {
        this._schedules = value;
        this.SchedulesSubject.next(value);
        if (this._schedules.length > 0) {
            if (this._schedules[0].Timer == true) {
            } else {
                // check if a schedule is checked and if so enable step2 if not leave step 2 disabled
                // this.EnableStep2.next();
                if (this.selectedContracts.length > 0) {
                    this.StopAnimation.next(null);
                    const button = document.getElementById('applyButton');
                    button.classList.remove('blinking');
                    this.selectedContracts.forEach(contract => {
                        this.ApplyInvoiceChanges.next({
                            PeriodEndDate: contract.PeriodEndDate,
                            ContractSelected: contract.ContractSelected,
                            ContractListID: contract.ContractListID,
                            CNListID: contract.CNListID,
                            FPInvoiceAmount: contract.FPInvoiceAmount
                        });
                    });
                    setTimeout(() => {
                        this.GetSchedules.next({
                            FyStartDate: null,
                            FYEndDate: null
                        });
                    }, 1500);

                    this.selectedContracts = [];
                }
            }
        }
    }
    get schedules(): Array<RecalculateSchedule> {
        return this._schedules;
    }

    @Input() loading: boolean;

    @Input() dialogAction$: Observable<string>;

    @Input() initialContracts: RecalculateContract[];
    selectedContracts: RecalculateContract[] = [];

    @Output() ApplyInvoiceChanges = new ReplaySubject<any>(1);

    @Output() GetContracts = new ReplaySubject<{
        PeriodStartDate?: Date;
        PeriodEndDate?: Date;
    }>(1);

    @Output() StopAnimation = new ReplaySubject<any>(1);

    @Output() DisableStep2 = new ReplaySubject<any>(1);

    @Output() EnableStep2 = new ReplaySubject<any>(1);

    @Output() GetSchedules = new ReplaySubject<any>(1);

    public currencyFormatter = new Intl.NumberFormat('en-US', {
        style: 'currency',
        currency: 'USD'
    });

    active = true;

    periodString: string;
    buttonText = 'Apply Changes';
    dateText = '';

    dataBeforeUpdate: RecalculateContract;

    constructor(private log: LoggingService) {
        super();
    }

    ngOnInit(): void {
        this.setupSubscriptions();
    }

    ngOnDestroy() {
        this.active = false;
    }

    setupSubscriptions() {
        if (this.dialogAction$) {
            this.dialogAction$
                .pipe(takeWhile(() => this.active))
                .subscribe(x => {
                    if (x && x == 'apply') {
                        this.onApplyInvoiceChanges();
                    } else if (x && x == 'discard') {
                        this.onDiscardInvoiceChanges();
                    }
                });
        }
    }

    onDialogAction($event) {
        if ($event && $event == 'apply') {
            this.onApplyInvoiceChanges();
        } else if ($event && $event == 'discard') {
            this.onDiscardInvoiceChanges();
        }
    }

    onCheckboxChange($event, rowData) {
        const index = this.contracts.findIndex(
            x => x.ContractListID == rowData.ContractListID
        );
        this.contracts[index] = rowData;
        const button = document.getElementById('applyButton');
        this.StopAnimation.next(button);
        const oldData = this.initialContracts.find(
            x => x.ContractDesc == rowData.ContractDesc
        );
        if ($event.checked != oldData.ContractSelected) {
            this.selectedContracts.push(rowData);
            button.classList.add('blinking');
            // this.DisableStep2.next();
        } else {
            if (
                this.selectedContracts.findIndex(
                    x => x.ContractListID == rowData.ContractListID
                ) != -1
            ) {
                this.selectedContracts.splice(
                    this.selectedContracts.findIndex(
                        x => x.ContractListID == rowData.ContractListID
                    ),
                    1
                );
                this.StopAnimation.next(null);
            }

            if (this.selectedContracts.length <= 0) {
                button.classList.remove('blinking');
                // this.EnableStep2.next();
            }
        }
    }

    onEditInit($event) {
        // this.dataBeforeUpdate = this.contracts.find(x => x.ContractDesc === $event.data.ContractDesc);
    }

    onEditComplete($event) {
        const button = document.getElementById('applyButton');
        this.StopAnimation.next(button);
        // this.DisableStep2.next();
        button.classList.remove('blinking');
        button.classList.add('blinking');
        const index = this.contracts.findIndex(
            x => x.ContractListID == $event.data.ContractListID
        );
        this.selectedContracts.push($event.data);
    }

    onDiscardInvoiceChanges() {
        this.StopAnimation.next(null);
        this.selectedContracts = [];
        const button = document.getElementById('applyButton');
        button.classList.remove('blinking');
        this.GetContracts.next({
            PeriodStartDate: this.contracts[0].PeriodStartDate,
            PeriodEndDate: this.contracts[0].PeriodEndDate
        });
    }

    onApplyInvoiceChanges() {
        this.GetSchedules.next({
            FyStartDate: null,
            FYEndDate: null
        });
    }
}
